import {
  type MENU_CONFIG_PAYLOAD,
  type VENDOR_CONFIG_PAYLOAD,
} from "@sinch/bus";
import { atom } from "jotai";

export const menuConfigAtom = atom<MENU_CONFIG_PAYLOAD>(null);
export const vendorConfigAtom = atom<VENDOR_CONFIG_PAYLOAD>(null);

export const inboxMfeElementAtom = atom<HTMLDivElement | null>(null);
